import React from 'react'
import Header from '../../CoreFile/Header'
import { Serviceherosection } from './Serviceherosection'

import { Code, Palette, Globe, Rocket, BarChart, Zap, ShieldCheck, Users } from 'lucide-react';
import Footer from '../../CoreFile/Footer';
import Packagessection  from './Packagessection';
import Faq from '../Faq';

export const Service = () => {
    const services = [
        {
            title: "Forex Trading Tools",
            description: " Access powerful tools to analyze the market, manage trades, and track performance.",
            icon: <Code className="h-6 w-6 text-white" />
          },
          {
            title: "Automated Trading Bots",
            description: "Let our intelligent bots handle trades 24/7—saving you time and effort.",
            icon: <Palette className="h-6 w-6 text-white" />
          },
          {
            title: "Live Market Insights",
            description: " Get real-time data and market analysis to make informed decisions.",
            icon: <Globe className="h-6 w-6 text-white" />
          },
          {
            title: "User-Friendly Dashboard",
            description: "Manage your trading activities with ease through our simple and intuitive platform.",
            icon: <Rocket className="h-6 w-6 text-white" />
          },
      
         
      ];
      const features = [
        {
          name: 'Smart Automation',
          description: 'Let technology do the trading while you focus on your goals.',
          icon: (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
        },
        {
          name: 'Beginner-Friendly',
          description: ' No experience? No problem. We make Forex trading easy for everyone.',
          icon: (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          ),
        },
        {
          name: '24/7 Reliability',
          description: ' Our bots work around the clock so you never miss an opportunity..',
          icon: (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
        },
        {
          name: 'Secure & Transparent',
          description: ' We prioritize your safety with advanced security measures and full transparency.',
          icon: (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
        },
      ];
    
   
      
      
  return (
    <>
    <Header/>
    <Serviceherosection/>
    <div className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
       
          <div className="text-4xl font-bold text-gray-900 sm:text-5xl">
          What We Offer
          </div>
          <p className="mt-6 max-w-2xl text-xl text-gray-600 mx-auto">
          Our services are built for both beginners and professionals looking to maximize their trading potential.
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-y-8 gap-x-8 sm:grid-cols-2 lg:grid-cols-4">
            {services.map((service, index) => (
              <div key={index} className="group relative">
                <div className="overflow-hidden rounded-2xl shadow-lg transition-all duration-300 group-hover:shadow-xl bg-white hover:bg-gradient-to-br hover:from-blue-50 hover:to-indigo-50">
                  <div className="px-6 py-10">
                    <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 group-hover:scale-110 transition-transform duration-300">
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors duration-300">{service.title}</h3>
                    <p className="mt-3 text-base text-gray-600">
                      {service.description}
                    </p>
                    <div className="mt-6">
                      <a href="#" className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-800">
                        Learn more
                        <svg className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <a href="#" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-300">
            Explore All Services
            <svg className="ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <div className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Features</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Why Choose Our Services
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
          We focus on results, reliability, and ease of use. Here’s why traders around the world trust us.e
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                    {feature.icon}
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
   <Packagessection/>
   <Faq />
    <Footer/>
    </>
  )
}
